// extracted by mini-css-extract-plugin
export default {"paymentTab":"paymentTab_paymentTab__PxI-j","paymentTabContents":"paymentTab_paymentTabContents__FuXVX","card":"paymentTab_card__YT4y2"};